export const projectPageTableColumnOptions = {
    data: [
        { field: 'projectName', label: 'Project Name' },
        { field: 'projectStage', label: 'Project Stage' },
        { field: 'estimatedProjectCost', label: 'Estimated Value' },
        { field: 'branchLocation', label: 'Branch Location' },
        { field: 'quoteDueDate', label: 'Quote Due Date' },
        { field: 'submittalDueDate', label: 'Submittal Due Date' },
        { field: 'omDueDate', label: 'O&M Due Date' },
        { field: 'quoteOwner', label: 'Quote Owner' },
        { field: 'submittalOwner', label: 'Submittal Owner' },
        { field: 'omOwner', label: 'O&M Owner' },
        { field: 'address1', label: 'Address Line 1' },
        { field: 'address2', label: 'Address Line 2' },
        { field: 'country', label: 'Country' },
        { field: 'city', label: 'City' },
        { field: 'state', label: 'State' },
        { field: 'zip', label: 'Zip' },
        { field: 'buildingType', label: 'Market vertical' },
        { field: 'constructionScope', label: 'Construction Scope' },
        { field: 'size', label: 'Square Footage' },
        { field: 'stakeholders[0]', label: 'Stakeholder #1' },
        { field: 'stakeholders[1]', label: 'Stakeholder #2' },
        { field: 'stakeholders[2]', label: 'Stakeholder #3' },
        { field: 'stakeholders[3]', label: 'Stakeholder #4' },
        { field: 'stakeholders[4]', label: 'Stakeholder #5' },
        { field: 'erpId', label: 'Project ERP ID' },
        { field: 'projectId', label: 'Project ID' }
    ]
};
